import React, { useState, useEffect } from "react";

import MainButton from "../../shared/Button";
import AuthLayout from "./AuthLayout";
import borderBack from "../../../assets/images/borderBack.png";
import CheckIcon from "@mui/icons-material/Check";
import { useNavigate } from "react-router-dom";
import { Container } from "@mui/material";
import FormMainLayouts from "../../layouts/FormMainLayouts";
import { USERINFO } from "../../../constants/apiEndPoints";
import httpRequest from "../../../axios/index";
import { toast } from "react-hot-toast";
import {
  Header,
  Linked,
  Maincontant,
  StyledRadioMain,
} from "./styles/CustomerTypeStyle";
import { useDispatch, useSelector } from "react-redux";
import { loginSuccess } from "../../../redux/slice/user/UserSlice";

const CustomerType = () => {
  const [Loading, setLoading] = useState(false);
  const UserInformation = useSelector((state) => state.auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedValue, setSelectedValue] = useState("");
  const handleRadioChange = (event) => {
    setSelectedValue(event.target.value);
  };

  useEffect(() => {
    if (UserInformation) {
      const user = UserInformation.user;
      if (user.user_type !== null && !user.review_approved) {
        navigate("/pending-appproval");
      } else if (user.status === "active" && user.user_type !== null) {
        navigate("/profile");
      }
    }
  }, [UserInformation]);

  const onClickMain = async () => {
    if (selectedValue === "regular") {
      try {
        setLoading(true);
        const resp = await httpRequest.patch(USERINFO, {
          user: {
            user_type: selectedValue,
          },
        });
        if (resp?.status === 200) {
          const userToken = { auth_token: UserInformation?.user?.auth_token };
          const UserData = { ...resp?.data?.user, ...userToken };
          dispatch(loginSuccess(UserData));
          if (resp?.data?.user.status === "pending") {
            navigate("/pending-appproval");
          }
        }
        setLoading(false);
      } catch (error) {
        toast.error(error?.response?.data?.message || "Something went wrong");
        setLoading(false);
      }

      // navigate("/payment-method");
    }
    if (selectedValue === "business") {
      navigate("/business-customer");
    }
  };
  const ClickHandler = (event) => {
    event.preventDefault();
  };

  return (
    <>
      <Container maxWidth="lg">
        <AuthLayout arrow={true}>
          <Header>
            <Linked to="/verification" onClick={ClickHandler}>
              <img src={borderBack} alt="Linkarrow" />
            </Linked>
            <Maincontant>
              <h6>Customer Type</h6>
              <p>
                What type of customer are you? Select your preferable option
              </p>
            </Maincontant>
          </Header>
          <FormMainLayouts>
            <StyledRadioMain>
              <label className="container">
                Regular
                <input
                  type="radio"
                  name="radio"
                  value="regular"
                  checked={selectedValue === "regular"}
                  onChange={handleRadioChange}
                />
                <span className="checkmark">
                  <CheckIcon className="icon" />
                </span>
              </label>
              <label className="container">
                Business
                <input
                  type="radio"
                  name="radio"
                  checked={selectedValue === "business"}
                  value="business"
                  onChange={handleRadioChange}
                />
                <span className="checkmark">
                  <CheckIcon className="icon" />
                </span>
              </label>
            </StyledRadioMain>
            <MainButton
              type="button"
              label="Continue"
              MT="160"
              onClick={onClickMain}
              disabled={selectedValue === "" ? true : false}
              isLoading={Loading}
            />
          </FormMainLayouts>
        </AuthLayout>
      </Container>
    </>
  );
};

export default CustomerType;
